const themes = {
  "carolinaterbeck@macro.com.ar": {
    img:
      "https://res.cloudinary.com/dffufplmy/image/upload/v1527616283/01_macro_negativo_color_300.jpg",
    color1: "#0093d0",
    color2: "#0193c980"
  }
};

export default themes;
